export interface FreeVhfScenarioBadgeProps {
  /** Badge text (e.g. scenario label or "Routine  -  ship to ship"). */
  label: string;
  className?: string;
}

/**
 * Small pill/label for the scenario (e.g. above the player on M1/M2 lesson pages).
 */
export default function FreeVhfScenarioBadge({
  label,
  className = "",
}: FreeVhfScenarioBadgeProps) {
  return (
    <span
      className={`inline-block rounded bg-primary-50 text-primary text-xs font-medium px-2 py-1 ${className}`}
    >
      {label}
    </span>
  );
}
